export let exportMenu = [
	{
		icon: "uil-setting sidebar-icon",
		children: [
			{
				title: true,
				i18n: "home",
			},
			// {
			// 	url: "/admin/users",
			// 	i18n: "users",
			// 	icon: "uil-users-alt",
			// 	active: false,
			// },
			{
				url: "/admin/poses",
				i18n: "pos",
				icon: "uil-shop",
				active: false,
			},
			{
				url: "/admin/payments-history",
				i18n: "payment_history",
				icon: "uil-history",
				active: false,
			},
		]
	},
]